
import { getCurrentDate } from '../../time';
import { throwErrorMessage } from '../../lib/error_helper';
import { buildImputation } from '../imputations/imputationsCast';
import { getInterventionType } from '../activityTypes/activityTypesActions';
import { checkOverlapping } from '../imputations/imputationsChecks';
import { loadImputationsByDay, getImputationsInProgress, setAllInterventionsAction } from '../imputations/imputationsActions'
import {
    setCurrentTimeSlotAction, generateDefaultBloc, setBlocsAction, interventionsIsLoading, setFilteredAndSortedInterventions
} from '../intervention/interventionActions';
import { submitInterventionInDb } from '../intervention/interventionEditionActions';
import {
    stopInProgressActivity, addImputationInDb, updateImputationInDb,
    adaptImputationForMyOpen, adaptImputationForDb
} from '../../redux/imputations/imputationsEditionActions'
import {
    castInterventionFromDb
} from '../../redux/intervention/interventionsCast'
import {
    TIME_SLOT_BLOC_TYPE_CODE,
    TIME_SLOT_START_DAY,
    TIME_SLOT_START_TIME,
    TIME_SLOT_END_DAY,
    TIME_SLOT_END_TIME,
} from '../intervention/interventionConstants';
import { guid, clone } from '../../utils';
import moment from 'moment';
import { timeToFloat, getDayString } from "../../time";
import { createOrGetDayByDate } from '../day/dayActions'
import { MODULE_SAISIE_TEMPS } from '../authorizedApps/authorizedAppsConstants'
import { haveModuleAuthorization } from '../authorizedApps/authorizedAppsActions'
import db from '../../db';


export function buildAndCreateImputationFromWorkOrder(intervention, imputationInformations, user) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            let gpsPosition = imputationInformations.gpsPosition;
            let gpsAddress;
            let date = getCurrentDate(true);
            let day = imputationInformations.startDay.day.id;
            let gpsStopped = false;
            let customerLabel = "";
            let business = "";

            dispatch(haveModuleAuthorization(MODULE_SAISIE_TEMPS, user)).then((haveAuthorization) => {
                if (!haveAuthorization)
                    return resolve();

                getInterventionType().then(activityType => {
                    if (!activityType)
                        return

                    if (intervention.delivery_customer_id) {
                        customerLabel = intervention.delivery_customer_id.name;

                        if (intervention.delivery_customer_id.customer_code)
                            customerLabel = customerLabel.concat(" (".concat(intervention.delivery_customer_id.customer_code).concat(")"))
                    }

                    if (intervention.name)
                        business = intervention.name
                    else
                        business = "OT-" + intervention.mobile_id

                    let workOrderDetail = {
                        customer: customerLabel,
                        description: intervention.equipment_description + "\r\n" + intervention.failure_description,
                    }

                    let endDate = null;
                    let inProgress = true;

                    if (imputationInformations.endDate) {
                        endDate = imputationInformations.endDate;
                        inProgress = false;
                    }

                    let temp = buildImputation(day, date, imputationInformations.startTime, endDate, activityType,
                        business, "", workOrderDetail, !gpsStopped,
                        gpsStopped === false ? gpsPosition : undefined, gpsAddress, inProgress);

                    dispatch(createImputationFromWorkOrder(temp, imputationInformations, user)).then(() => {
                        return resolve(temp)
                    }).catch(err => {
                        err.message = "Une erreur s'est produite lors de la création de l'imputation: [" + err.message +
                            "] Veuillez vous rendre sur le module de saisie des temps pour saisir l'imputation manuellement"
                        dispatch(throwErrorMessage(err));
                        return reject(err);
                    });
                }).catch(err => {
                    err.message = "Une erreur s'est produite lors de la création de l'imputation: [" + err.message +
                        "] Veuillez vous rendre sur le module de saisie des temps pour saisir l'imputation manuellement"
                    dispatch(throwErrorMessage(err));
                    return reject(err);
                });
            }).catch(err => {
                err.message = "Une erreur s'est produite lors de la création de l'imputation: [" + err.message +
                    "] Veuillez vous rendre sur le module de saisie des temps pour saisir l'imputation manuellement"
                dispatch(throwErrorMessage(err));
                return reject(err);
            });
        })
    }
}

export function loadCurrentTimeSlot(blocs, blocTypes, user) {
    return (dispatch) => {

        return new Promise(async (resolve) => {
            let timeSlotBlocType = blocTypes.find(bt => bt.code === TIME_SLOT_BLOC_TYPE_CODE);

            if (!timeSlotBlocType) {
                console.error("Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] est introuvable")
                return;
            }

            let timeSlot = {
                startDate: moment().seconds(0).milliseconds(0),
                endDate: null,
                startTime: moment().seconds(0).milliseconds(0).add(-1, 'minutes'),
                endTime: null,
            }

            let blocsFound = blocs.filter(b => b.type_id === timeSlotBlocType.id && endDateIsEmpty(b, timeSlotBlocType) && (b.create_uid === user.id || !b.create_uid))

            if (blocsFound.length <= 0) {
                console.error("La plage horaire en cours est introuvable")
                dispatch(setCurrentTimeSlotAction(timeSlot));
                return resolve(timeSlot);
            }

            let inProgressTimeSlotBloc = blocsFound
                .sort((a, b) => moment(b.mobile_creation_date).diff(moment(a.mobile_creation_date)))[0];


            let timeSlotFieldTypeStartDateId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_START_DAY);
            let timeSlotFieldTypeEndDateId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_END_DAY);
            let timeSlotFieldTypeStartTimeId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_START_TIME);
            let timeSlotFieldTypeEndTimeId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_END_TIME);

            let timeSlotStartDateFieldValue = inProgressTimeSlotBloc.field_ids.find(f => f.type_id === timeSlotFieldTypeStartDateId.id).value_date
            let timeSlotEndDateFieldValue = inProgressTimeSlotBloc.field_ids.find(f => f.type_id === timeSlotFieldTypeEndDateId.id).value_date
            let timeSlotStartTimeFieldValue = inProgressTimeSlotBloc.field_ids.find(f => f.type_id === timeSlotFieldTypeStartTimeId.id).value_float
            let timeSlotEndTimeFieldValue = inProgressTimeSlotBloc.field_ids.find(f => f.type_id === timeSlotFieldTypeEndTimeId.id).value_float

            timeSlot = {
                startDate: moment(timeSlotStartDateFieldValue),
                endDate: moment(timeSlotEndDateFieldValue),
                startTime: timeSlotStartTimeFieldValue,
                endTime: timeSlotEndTimeFieldValue,
            }

            dispatch(setCurrentTimeSlotAction(timeSlot));

            return resolve(timeSlot);
        })
    }
}

export function addTimeSlotBloc(blocs, blocTypes, intervention, user, startDate, startTime, stateAccessor) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            let blocType = blocTypes.find((bt) => bt.code === TIME_SLOT_BLOC_TYPE_CODE);

            if (!blocType) {
                let error = {
                    title: "Erreur",
                    message: "Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] est introuvable"
                }

                return reject(error);
            }

            if (!blocType.published) {
                let error = {
                    title: "Erreur",
                    message: "Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] n'est pas publié"
                }

                return reject(error);
            }

            let bloc = generateDefaultBloc(blocType, intervention.id, user, stateAccessor, guid());
            bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
            bloc.mobile_write_id = user.id;
            let dtStartTime = startTime.toDate();
            bloc = updateTimeSlotField(bloc, blocType, timeToFloat(dtStartTime.getHours(), dtStartTime.getMinutes()), TIME_SLOT_START_TIME, "value_float")
            bloc = updateTimeSlotField(bloc, blocType, startDate, TIME_SLOT_START_DAY, "value_date")

            blocs.push(bloc);

            dispatch(setBlocsAction(blocs));
            intervention.report_block_ids = blocs;
            return submitInterventionInDb(intervention, blocs).then(() => {
                dispatch(loadCurrentTimeSlot(blocs, blocTypes, user));
                return resolve(intervention);
            }).catch((err) => {
                console.error("Une erreur s'est produite lors de l'ajout d'une plage horaire", err);
                return resolve(intervention);
            });
        })
    }
}

function updateTimeSlotField(blocValue, blocType, value, fieldCode, impactedProperty) {
    let fieldType = blocType.field_ids.find(f => f.code === fieldCode)
    let fieldValue = blocValue.field_ids.find(f => f.type_id === fieldType.id)
    fieldValue[impactedProperty] = value;

    return blocValue;
}

export function completeTimeSlotBloc(blocs, blocTypes, intervention, user, timeSlot) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {

            let blocType = blocTypes.find((bt) => bt.code === TIME_SLOT_BLOC_TYPE_CODE);

            if (!blocType) {
                let error = {
                    title: "Erreur",
                    message: "Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] est introuvable"
                }

                return reject(error);
            }

            if (!blocType.published) {
                let error = {
                    title: "Erreur",
                    message: "Le type de bloc plage horaire [" + TIME_SLOT_BLOC_TYPE_CODE + "] n'est pas publié"
                }

                return reject(error);
            }

            let blocsFound = blocs.filter(b => b.type_id === blocType.id && endDateIsEmpty(b, blocType) && (b.create_uid === user.id || !b.create_uid))

            if (blocsFound.length <= 0) {
                console.error("Plage horaire introuvable")
                //On trouve pas de plage horaire. Il y a eu une erreur mais ça ne doit pas être bloquant
                return resolve(intervention);
            }

            let bloc = blocsFound
                .sort((a, b) => moment(b.mobile_creation_date).diff(moment(a.mobile_creation_date)))[0];
            bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
            bloc.mobile_write_id = user.id;

            let dtEndTime = timeSlot.endTime.toDate();
            bloc = updateTimeSlotField(bloc, blocType, timeToFloat(dtEndTime.getHours(), dtEndTime.getMinutes()), TIME_SLOT_END_TIME, "value_float")
            bloc = updateTimeSlotField(bloc, blocType, dtEndTime, TIME_SLOT_END_DAY, "value_date")

            dispatch(setBlocsAction(blocs));
            intervention.report_block_ids = blocs;
            submitInterventionInDb(intervention, blocs);
            dispatch(setCurrentTimeSlotAction(null));

            return resolve(intervention)
        })
    }
}

function endDateIsEmpty(blocValue, blocType) {
    let fieldType = blocType.field_ids.find(f => f.code === TIME_SLOT_END_DAY)
    let fieldValue = blocValue.field_ids.find(f => f.type_id === fieldType.id)
    return !fieldValue.value_date;
}

export function completeImputationFromWorkOrder(intervention, timeSlot, user) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {

            dispatch(haveModuleAuthorization(MODULE_SAISIE_TEMPS, user)).then(async (haveAuthorization) => {
                if (!haveAuthorization)
                    return resolve();

                getImputationsInProgress().then(async (imputations) => {

                    if (imputations.length !== 1) {
                        console.error("Impossible de compléter l'imputation car aucune ou plusieurs imputations sont actuellement en cours, ce qui n'est pas possible.");
                        return reject({});
                    }

                    let imputation = adaptImputationForMyOpen(imputations[0]);

                    if (!imputation.activity.intervention) {
                        console.error("Impossible de compléter l'imputation car celle trouvée n'est pas du type OT.");
                        return reject({});
                    }

                    let otherImputation = null;
                    imputation.in_progress = false;
                    let startDate = moment(timeSlot.startDate);
                    let endDate = moment(timeSlot.endDate);

                    if (imputation.date_start.isSame(endDate, "day")) {
                        imputation.date_end = moment(timeSlot.endTime);
                    } else {
                        imputation.date_end = startDate.clone().hours(23).minutes(59).seconds(0);
                        let secondImputationStartDate = endDate.clone().hours(0).minutes(0).seconds(0);
                        let day = await createOrGetDayByDate(user.id, getDayString(secondImputationStartDate.toDate()), true);

                        let originalEndTimeMoment = moment(timeSlot.endTime);
                        let secondImputationEndDate = secondImputationStartDate.clone()
                            .hours(originalEndTimeMoment.hours()).minutes(originalEndTimeMoment.minutes())

                        otherImputation = {
                            startDate: secondImputationStartDate,
                            startTime: secondImputationStartDate,
                            startDay: day,
                            gpsPosition: imputation.gps_coord,
                            endDate: secondImputationEndDate,
                        }
                    }

                    return dispatch(stopImputation(imputation)).then(() => {
                        if (otherImputation) {
                            dispatch(buildAndCreateImputationFromWorkOrder(intervention, otherImputation, user)).then(() => {
                                return resolve(imputation);
                            }).catch(err => {
                                throw err
                            });
                        } else {
                            return resolve(imputation);
                        }
                    }).catch(err => {
                        throw err;
                    });
                }).catch(err => {
                    err.message = "Une erreur s'est produite lors de l'interruption de l'imputation: [" + err.message +
                        "] Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement"
                    dispatch(throwErrorMessage(err));
                    return reject(err);
                });
            })
        })
    }
}

function stopImputation(imputation) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {

            return dispatch(updateImputationInDb(imputation.id, imputation)).then(imputation => {
                return resolve(imputation);
            }).catch((err) => {
                console.error(err);
                return reject({
                    title: "Erreur",
                    message: "La ligne de temps associée à l'OT n'a pu être arrêtée.",
                });
            });
        })
    }
}

function createImputationFromWorkOrder(imputationToCreate, timeSlot, user) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {

            getImputationsInProgress().then(async (inProgressImputations) => {
                if (inProgressImputations.length === 0) {
                    dispatch(createImputation(imputationToCreate)).then((createdImputation) => {
                        return resolve(createdImputation);
                    })
                        .catch(err => {
                            err.message = "Une erreur s'est produite lors de la création de l'imputation liée à l'OT: [" + err.message +
                                "] Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement"
                            dispatch(throwErrorMessage(err));
                            return reject(err);
                        });
                } else {
                    //On a une imputation en cours
                    let inProgressImputation = adaptImputationForMyOpen(inProgressImputations[0]);
                    let continuationOfImputation = null;
                    let startDate = moment(timeSlot.startDate);
                    let endDate = moment(timeSlot.endDate);
                    inProgressImputation.in_progress = false;

                    //L'imputation en cours a commencé sur un jour différent que le jour courant (Aujourd'hui)
                    if (inProgressImputation.date_start.isSame(startDate, "day")) {
                        inProgressImputation.date_end = moment(timeSlot.startTime);
                    } else {
                        if (inProgressImputation.date_start.diff(startDate, "days") > 1) {
                            let err = {
                                title: "Une erreur s'est produite lors de la création de l'imputation",
                                message: "L'imputation en cours chevauche plus de deux jours. "
                                    + "Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement"
                            }

                            dispatch(throwErrorMessage(err));
                            return reject(err);
                        }

                        inProgressImputation.date_end = moment(inProgressImputation.date_start).clone().hours(23).minutes(59);
                        let secondImputationStartDate = endDate.clone().hours(0).minutes(0);
                        let day = await createOrGetDayByDate(user.id, getDayString(secondImputationStartDate.toDate()), true);

                        continuationOfImputation = clone(inProgressImputation);
                        continuationOfImputation.date_start = secondImputationStartDate;
                        continuationOfImputation.date_end = moment(timeSlot.startTime);
                        continuationOfImputation.day_id = day.day.id;
                        continuationOfImputation.date = getCurrentDate(true);
                        continuationOfImputation.in_progress = false;
                        continuationOfImputation.id = guid();
                    }

                    if (inProgressImputation.date_end.isSameOrBefore(inProgressImputation.date_start)) {
                        console.error("Impossible d'arrêter l'imputation en cours car la date de fin est inférieure à la date de début");
                        let err = {
                            title: "Une erreur s'est produite lors de l'arrêt de l'imputation en cours",
                            message: "La date de fin est inférieure à la date de début"
                        }
                        return reject(err);
                    }

                    //On termine l'imputation en cours
                    return dispatch(stopImputation(inProgressImputation)).then(() => {

                        if (continuationOfImputation) {
                            //On avait une imputation en cours hier qu'on a pas terminé
                            //Elle va continuer jusqu'à maintenant donc après avoir terminé celle d'hier
                            //On créé et termine aussitôt la continuité de cette imputation pour aujourd'hui
                            dispatch(createImputation(continuationOfImputation)).then(() => {
                                //Une fois que c'est fait on peut désormais créer l'imputation liée à l'OT qu'on démarre
                                dispatch(createImputation(imputationToCreate)).then((createdImputation) => {
                                    return resolve(createdImputation);
                                })
                                    .catch(err => {
                                        console.error("Une erreur s'est produite lors de la création de l'imputation liée à l'OT: [" + err.message +
                                            "] Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement");
                                        throw err
                                    });
                            }).catch(err => {
                                console.error("Erreur lors de la création de la continuation de l'imputation en cours")
                                throw err;
                            });
                        } else {
                            //On créé l'imputation liée à l'OT qu'on démarre
                            dispatch(createImputation(imputationToCreate)).then((createdImputation) => {
                                return resolve(createdImputation);
                            })
                                .catch(err => {
                                    console.error("Une erreur s'est produite lors de la création de l'imputation liée à l'OT: [" + err.message +
                                        "] Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement")
                                    throw err;
                                });
                        }
                    }).catch(err => {
                        err.message = "Une erreur s'est produite lors de l'arrêt de l'imputation en cours: [" + err.message +
                            "] Veuillez vous rendre sur le module de saisie des temps pour poursuivre la saisie manuellement"
                        dispatch(throwErrorMessage(err));
                        return reject(err);
                    });
                }
            });
        })
    }
}

function createImputation(imputation) {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {

            if (await checkOverlapping(imputation, false)) {
                return reject({
                    title: "Erreur",
                    message: "Une activité existe déjà sur cette période. Le chevauchement n'est pas autorisé",
                })
            } else {
                //Interruption de l'activité en cours
                let updatedActivity = await dispatch(stopInProgressActivity(imputation, (message) => {
                    return reject({
                        title: "Erreur",
                        message,
                    });
                }))

                if (!updatedActivity) {
                    return reject({
                        title: "Erreur",
                        message: "Erreur de traitement des données",
                    });
                } else {
                    dispatch(loadImputationsByDay(imputation.day_id));

                    let adaptedImputation = adaptImputationForDb(updatedActivity);
                    dispatch(addImputationInDb(adaptedImputation));
                    return resolve(updatedActivity)
                }
            }
        })
    }
}

export function loadImputationsWorkOrders(interventionsFilters = null, loaderIndicator = false, discreet) {
    return (dispatch) => {
        db.transaction("rw?", db.Intervention, () => {
            if (loaderIndicator && !discreet)
                dispatch(interventionsIsLoading(true));

            db.Intervention.toArray().then((interventions) => {
                let transformedInterventions = [];

                interventions.forEach((i) => {
                    transformedInterventions.push(castInterventionFromDb(i));
                })

                dispatch(setAllInterventionsAction(transformedInterventions));

                if (interventionsFilters) {
                    dispatch(setFilteredAndSortedInterventions(interventionsFilters, transformedInterventions));
                }

                if (loaderIndicator)
                    dispatch(interventionsIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : interventionActions - loadImputationsWorkOrders", err);

                if (!discreet) {
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des interventions !",
                    }))

                    if (loaderIndicator)
                        dispatch(interventionsIsLoading(false));
                }
            });
        }).catch((err) => {
            console.error("Erreur : interventionActions - loadImputationsWorkOrders", err);

            if (!discreet) {
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des interventions !",
                }))
                
                if (loaderIndicator)
                    dispatch(interventionsIsLoading(false));
            }
        });
    }
}
